import React, { useState } from 'react'
import { useEffect } from 'react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import { Button, Stack, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, Typography } from '@mui/material'
import { Item } from '../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { colors, excelHeader1Summry, excelHeader2Summary, pdfHeaderColumn1, pdfHeaderColumn2, jsPdfHeaderFooter, updateDetailData, LRWiseDetColumns, detailColumnsStyles, DetailWiseDrawCell, updateDetailDataForExcel, filterHeaderForLRWiseDetManageColumns, filterHeaderForLRWiseDetManageColumns1 } from './constants'
import { DetailLargePdf } from './LargePDF'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
import AppsIcon from '@mui/icons-material/Apps'
import { updateModal } from '../../../../store/common/common_action'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, generateDynamicColumnStyles } from '../../../common/helper'
import VirtualizedTable from '../../../common/virtualisedTable'
import { divideInNIntegers } from '../../../common/mathHelper'
import { exportToExcel } from '../../../common/hook'

const DetailTable = (props) => {
    const { loginCountryId,headerData, tableData, disableExcel, columnSummaryDefs, selectedFields, mainHeader, matchFields, columnSummaryDefsForExcel, allowFormatLR = 0,UseToPayAsCOD } = props
    const theme = useTheme()
    const dispatch = useDispatch()
    const { tableHeaderColor } = theme
    const { loginData } = useSelector(state => state?.common)
    const [showTableData, setShowTableData] = useState([])
    const [showTableDataForEx, setShowTableDataForEx] = useState([])
    const [searchResult, setSearchResult] = useState(true)
    const [largePDF, setLargePDF] = useState(false)
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const reportName ='Receive Report'
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const { generatePDF, load, } = { ...state }
    useEffect(() => {
        if (tableData?.length > 0) {
            const updateData = updateDetailData(tableData, headerData,columnSummaryDefs)
            const updatesDataForEx = updateDetailDataForExcel(tableData, headerData,UseToPayAsCOD,loginCountryId)
            setShowTableDataForEx(updatesDataForEx)
            setShowTableData(updateData)
        } else {
            setShowTableData([])
        }
    }, [tableData,columnSummaryDefs])

    const headers = columnSummaryDefs.map((item) => {
        return {
            header: item.header,
            field: item.field,
            headerSx: item.headerSx,
            exportHead: item.exportHead,
            textAlign: item.headerSx?.textAlign || 'left',
        }
    })
    const excelHeaders = headers.flatMap((col) => {
        if (typeof col.field === 'string' && col.field.includes('^^')) {
            const [field1, field2] = col.field.split('^^')
            const [header1, header2] = (col.exportHead || '').split('\n')
            return [
                { field: field1, header: header1, align: col.textAlign },
                { field: field2, header: header2, align: col.textAlign },
            ]
        }
        return { field: col.field, header: col.exportHead, align: col.textAlign }
    })
    const lengths = divideInNIntegers(excelHeaders.length, 3)
    let index = 0
    const pickedHeaders = []
    lengths.forEach((span) => {
        pickedHeaders.push(excelHeaders[index].field)
        index += span
    })
    const excelData = showTableData.map((row) => {
        if (row.dataType === 'subHeader') {
          const colSpan = row.colSpan
          const orderedKeys = headers
            .map((c) => c.field)
            .filter((key) => key in colSpan)
            .map((key) => row[key])
          return {
            ...row,
            ...Object.fromEntries(pickedHeaders.map((key, i) => [key, orderedKeys[i]])),
            colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
          }
        }
        if (row.dataType === 'total') {
          return {
            ...row,
            colSpan: { [pickedHeaders[0]]: excelHeaders.findIndex((header) => header.field === 'Unit') },
          }
        }
        return row
      })
      const header1 = [
          [{ header: `Report For: ${reportName}`, field: '', span: filterHeaderForLRWiseDetManageColumns.length ,mainHeader:true}],
        ]


    const printClick = (isSave) => {
        const widthCell = calculateTotalTableWidth(columnSummaryDefs);
        setState({ ...state, load: true, generatePDF: true });
        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);

        const pdfColumns = columnSummaryDefs.map((col) => ({
            header: col.exportHead,
            dataKey: col.field,
            xlCol: col.xlCol
        }));
        const HeaderColumns1 = pdfHeaderColumn1.map((col) => ({
            header: col.exportHead,
            dataKey: col.field,
            xlCol: col.xlCol
        }));
        const HeaderColumns2 = pdfHeaderColumn2.map((col) => ({
            header: col.exportHead,
            dataKey: col.field,
            xlCol: col.xlCol
        }));

        const doc = new jsPDF({
            orientation: columnSummaryDefs.length > 11 ? 'l' : 'p',
            format: columnSummaryDefs.length > 11
                ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60)
                : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60),
            unit: 'px',
            compress: true
        });

        const pageWidth = doc.internal.pageSize.width;
        const pdfFontSize = pageWidth / (columnSummaryDefs.length > 11 ? 1122 : 793);
        const totalPagesExp = '{total_pages_count_string}';

        doc.setProperties({
            title: `Received Reports.pdf`,
            subject: 'Received Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        });

        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: { fillColor: [255, 255, 255] },
            columns: HeaderColumns1,
            body: [headerData],
            columnStyles: HeaderColumns1.reduce((acc, _, i) => {
                acc[i] = { fontSize: pdfFontSize * 14, halign: 'left', cellPadding: 12, minCellHeight: 36, font: 'Roboto', fontStyle: 'normal' };
                return acc;
            }, {}),
            theme: 'grid',
            startY: 120,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: pdfFontSize * 14,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(pdfFontSize * 16).setFont('Roboto', 'bold');
                doc.text(`Received Date : ${moment(headerData.fromDate).format('DD-MMM-YYYY')}  To  ${moment(headerData.toDate).format('DD-MMM-YYYY')}`, data.settings.margin.left, 100);
                doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 100, "right");
            },
        });

        // === Header Table 2 ===
        autoTable(doc, {
            margin: { top: 200, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: { fillColor: [255, 255, 255] },
            columns: HeaderColumns2,
            body: [headerData],
            columnStyles: HeaderColumns2.reduce((acc, _, i) => {
                acc[i] = { fontSize: pdfFontSize * 14, halign: 'left', cellPadding: 12, minCellHeight: 36, font: 'Roboto', fontStyle: 'normal' };
                return acc;
            }, {}),
            theme: 'grid',
            startY: 200,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: pdfFontSize * 14,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
        });

        // === Main Table (showTableData) ===
        autoTable(doc, {
            margin: { top: 200, left: 30, right: 30, bottom: 40 },
            columns: pdfColumns,
            body: showTableData,
            styles: { font: 'Roboto', fontSize: pdfFontSize * 12, cellPadding: 6, valign: 'middle' },
            columnStyles: pdfColumns.reduce((acc, _, i) => { acc[i] = { halign: 'left' }; return acc; }, {}),
            willDrawCell: (data) => {
                const row = data.row.raw;
                if (row.align?.[pdfColumns[data.column.index].dataKey]) {
                    data.cell.styles.halign = row.align[pdfColumns[data.column.index].dataKey];
                } else data.cell.styles.halign = getAutoAlign(row[pdfColumns[data.column.index].dataKey]);

                if (row.dataType === 'subHeader') doc.setFillColor(224, 235, 255);
                else if (row.dataType === 'tableHeader') doc.setFillColor(191, 225, 255);
                else if (row.dataType === 'total') doc.setFillColor(238, 238, 238);
                else doc.setFillColor(255, 255, 255);

                if (row.colSpan?.[pdfColumns[data.column.index].dataKey] > 1) {
                    data.cell.colSpan = row.colSpan[pdfColumns[data.column.index].dataKey];
                }
            },
            didDrawPage: (data) => {
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 20, 50, 50);
                doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'bold').setTextColor(16, 79, 162);
                doc.text('Cargo System | Received Report', 90, 50);
                doc.setFontSize(pdfFontSize * 16).setTextColor(0, 0, 0);
                // doc.text(`Company Name: ${loginData.strCompanyName}`, data.settings.margin.left, 70);
                doc.text(`Company Name: ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right");
                jsPdfHeaderFooter(data, loginData, totalPagesExp);
            },
            theme: 'grid',
            showHead: 'never'
        });

        if (typeof doc.putTotalPages === 'function') doc.putTotalPages(totalPagesExp);

        if (isSave) doc.save(`Receive Reports ${currentDateTime}.pdf`);

        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true });
            const pdfUrl = doc.output('bloburl')
            document.getElementById('recvdDetailsWiseOutput').data = pdfUrl
            // document.getElementById('recvdDetailsWiseOutput').data = doc.output('datauristring', 'Receive Reports.pdf');
            focusElemnt("backBtn");
        }, 2000);
    };



    const getAutoAlign = (value) => {
        if (value === null || value === undefined) return 'left'
        if (typeof value === 'number') return 'right'
        if (!isNaN(value) && value !== '') return 'right' // numeric string
        return 'left'
    }
    const DeliveryBody = ({ row, index, tableHeaderColor, columnDefs }) => {
        if (!row) return null

        const dataType = row.dataType || 'entry'

        const getStyles = (field, defaultAlign) => {
            const value = row[field]

            const common = {
                minHeight: '36px',
                fontSize: '12px',
                color: '#444',
                padding: '10px 4px',
                whiteSpace: 'pre',
            }
            const textAlign =
                row.align?.[field] ||
                defaultAlign ||
                getAutoAlign(value)

            if (dataType === 'entry') {
                return {
                    ...common,
                    fontWeight: '500',
                    textAlign,
                    height: '36px',
                }
            }

            if (dataType === 'subHeader') {
                return {
                    ...common,
                    fontWeight: '600',
                    backgroundColor: tableHeaderColor?.isSubHeadingColor,
                    textAlign,
                }
            }

            if (dataType === 'tableHeader') {
                return {
                    ...common,
                    fontWeight: '600',
                    color: '#444444',
                    backgroundColor: '#bfe1ff',
                    textAlign,
                }
            }

            if (dataType === 'total') {
                return {
                    ...common,
                    fontWeight: '600',
                    backgroundColor: tableHeaderColor?.isTotalColor,
                    textAlign,
                }
            }

            return common
        }

        return (
            <>
                {(() => {
                    let skip = 0

                    return columnDefs.map((item, i) => {
                        if (skip > 0) {
                            skip--
                            return null
                        }

                        const colSpan = row.colSpan?.[item.field] || 1
                        skip = colSpan - 1

                        return (
                            <TableCell
                                className="reportTD"
                                key={item.field + i + index}
                                colSpan={colSpan}
                                style={getStyles(item.field, item.textAlign)}
                            >
                                {row[item.field]}
                            </TableCell>
                        )
                    })
                })()}
            </>
        )
    }


    const bodyContent = (index, obj) => {
        return <DeliveryBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={headers} />
    }
    return (
        <>
            <Stack style={{ margin: "0px 10px", marginRight: '0px' }}>
                <Item className='userReport'>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', }}>

                            <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                                Received Report
                            </Typography>
                            <Box
                                sx={{
                                    minHeight: '32px',
                                    display: 'flex',
                                    padding: '8px 12px',
                                    justifycontent: 'center',
                                    alignitems: 'center',
                                    gap: '6px',
                                    marginX: '10px',
                                    fontSize: '14px'
                                }}
                                id="dispatchReportManageColumn"
                                tabIndex={0}
                                onClick={() => dispatch(updateModal(true, "ReceivedManageColumns"))}
                            >
                                <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                                    <AppsIcon />
                                </span>
                                <span tabIndex={0} style={{ fontWeight: '600' }}>
                                    MANAGE COLUMNS
                                </span>
                            </Box>
                        </Box>
                    </Box>
                    {/* <Item className='userReport-heading'>

                    </Item> */}
                    <Item className='userReport-buttons'>
                        {searchResult ? <>
                            {disableExcel ?
                                <Box>
                                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>Export to Excel</Button>
                                </Box>
                                :
                                <Box onKeyDown={(e) => navigation3(e, "ExportToPdf", id.reportmainButton, () => { })}>
                                    <Button
                                        variant="outlined"
                                        sx={{ width: '100%' }}
                                        className="userWisereporttembtn"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            exportToExcel({
                                                fileName: `${reportName} ${currentDateTime}.xlsx`,
                                                sheetName: reportName,
                                                headersList: [header1, filterHeaderForLRWiseDetManageColumns, excelHeaders],
                                                dataList: [[], [headerData], excelData],
                                            })
                                        }}
                                    >
                                        Export to Excel
                                    </Button>
                                </Box>}
                            <Box>
                                <Button variant="outlined" className="userWisereporttembtn" id="ExportToPdf"
                                    onClick={() => {
                                        setSearchResult(false);
                                        // if (showTableData?.length > 200) {
                                        //     setLargePDF(true)
                                        // } else {
                                        //     printClick(true)
                                        // }
                                        printClick(true)
                                    }}
                                    onKeyDown={(e) => navigation3(e, "PrintBtn", disableExcel ? id.reportmainButton : "ExportToExl", () => { setSearchResult(false); printClick(true) })}
                                >
                                    Export to Pdf
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    variant="outlined" id="PrintBtn"
                                    className="userWisereporttembtn"
                                    onClick={() => {
                                        setSearchResult(false);
                                        // if (showTableData?.length > 200) {
                                        //     setLargePDF(true)
                                        // } else {
                                        //     printClick(false)
                                        // }
                                        printClick(false)
                                    }}
                                    onKeyDown={(e) => navigation3(e, id.fromDate, "ExportToPdf", () => { setSearchResult(true); printClick(false) })}
                                >
                                    Print
                                </Button>
                            </Box>
                        </> : <>
                            <Box>
                                <Button
                                    variant="outlined" id="backBtn"
                                    className="userWisereporttembtn"
                                    onClick={() => { setSearchResult(true); setLargePDF(false) }}
                                    onKeyDown={(e) => navigation3(e, id.fromDate, id.reportmainButton, () => { setSearchResult(true); setLargePDF(false); focusElemnt(id.reportmainButton) })}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>}

                    </Item>
                </Item>
            </Stack>
            {
                searchResult ?
                    <Stack sx={{ marginLeft: 2, marginRight: 2, height: 470 }} >
                        <VirtualizedTable
                            tableData={showTableData}
                            rowContent={bodyContent}
                            tableStyle={{ tableLayout: 'auto', width: '100%' }}
                            autoResize={true}
                        />
                    </Stack>
                    : largePDF ? <DetailLargePdf headerData={headerData} data={showTableData} /> :
                        <>
                            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                            {load ? (
                                <object
                                    id="recvdDetailsWiseOutput"
                                    type="application/pdf"
                                    width={"100%"}
                                    height="440"
                                    title="MTLPL -Cargo System - Receoived Report"
                                    aria-label="MTLPL -Cargo System - Receoived Report"
                                ></object>
                            ) : (
                                ''
                            )}
                        </>
            }

        </>
    )
}

export default DetailTable